import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Layout } from '@/components/custom/layout'
import { navigateGuard } from '@/utils/auth.js'
import { UserRole } from '@/constants/user.js'

export const Route = createFileRoute('/_auth/monitors')({
  beforeLoad: ({ location }) =>
    navigateGuard(location, [UserRole.ADMINISTRATOR, UserRole.SUPERVISOR]),
  component: () => (
    <Layout.Body>
      <Outlet />
    </Layout.Body>
  ),
})
